import { UserTransactionHistoryPojo } from './UserTransactionHistoryPojo';
import { ThirupaniDonationPojo } from './ThirupaniDonationPojo';

export class DummyThirupaniDonationTransactionPojo{

     thirupaniDonationPojo = new ThirupaniDonationPojo();
	 transaction = new UserTransactionHistoryPojo();

}